export default __webpack_public_path__ + "static/media/Favorite-selected.b5d8dc4c.svg";